import { DateTime } from 'luxon';

const toDateTime = (date, timeZone, local) => {
  if (!date) return null;

  let dt;

  if (date instanceof DateTime) {
    dt = date;
  } else {
    dt = date instanceof Date ? DateTime.fromJSDate(date) : DateTime.fromISO(date);
  }

  if (timeZone) {
    return dt.setZone(timeZone);
  }

  if (local) {
    return dt.toLocal();
  }

  return dt;
};

export default toDateTime;
